import * as React from 'react';
// MUIのコンポーネントをインポート
import { Box, Typography, Divider, CardActionArea, CardActions, Button  } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
// サンプル画像をインポート
import sampleImg from "../../statics/img/cat240.png";

// UCItemType型の定義
export type UCItemType = {
    title: string, // タイトル
    memo?: string, // メモ（オプション）
    url: string, // URL
    disabled?: boolean, // 無効化フラグ（オプション）
    img?: string, // 画像データ（オプション）
    thumbnailPath?: string, // サムネイルパス（オプション）
}

// コンポーネントのプロパティ型の定義
type Props = {
    data: UCItemType, // UCItemTypeのデータ
}

/** user コンテンツ一覧表示アイテム */
const UCItem = (props: Props) => {
    // プロパティからデータを取得
    const {title, memo , url, disabled, img, thumbnailPath} = props.data;
    // サムネイルのデータURIを生成
    const thumbnail = (thumbnailPath?.toLocaleLowerCase().includes("png") ? "data:image/png;base64," : "data:image/jpeg;base64,") + img;

    return (
        // カードコンポーネントの作成
        <Card sx={{ display: 'flex', margin: 2 }}>
            {/* カードのクリックアクションエリア */}
            <CardActionArea href={`/${url}`} disabled={disabled}>
                {/* カードのレイアウト設定 */}
                <Box sx={{ display: 'flex', flexDirection: 'row' }} bgcolor={disabled ? 'grey' : 'white'}>
                    {/* 画像を表示 */}
                    <CardMedia
                        component="img"
                        sx={{ width: '240px', height: '240px' }}
                        image={thumbnail}
                        alt=""
                    />
                    {/* カードの内容 */}
                    <CardContent>
                        {/* タイトルを表示 */}
                        <Typography variant='h5'>
                            {title}
                        </Typography>
                        {/* メモを表示 */}
                        <Typography variant='subtitle2'>
                            {memo}
                        </Typography>
                    </CardContent>
                </Box>
            </CardActionArea>
        </Card>
    );
}

// コンポーネントをエクスポート
export default UCItem;